import {
  PublisherOrderFilterField,
  PublisherOrderFilterFieldMap,
} from 'respona_api/generated/order-publisher_pb';
import { FilterJoins } from '@constants/filters/filterOperations';
import { FilterFieldType as FilterStateType } from '@ts/filterField.type';

type FilterFieldType = {
  label: string;
  value: PublisherOrderFilterFieldMap[keyof PublisherOrderFilterFieldMap];
  type: 'string' | 'boolean' | 'number' | 'enum' | 'date' | 'enumString';
  inputOptions?: { value: string | number; label: string }[];
};

export const getPublisherOrderFilterOptionsMap = (): Partial<
  Record<number, { value: number | string; label: string }[]>
> => ({
  [PublisherOrderFilterField.DROPDOWN_ORDER_STATUS]: [
    { value: 'PENDING_PUBLISHER_APPROVAL', label: 'Pending Approval' },
    { value: 'REVISION_REQUESTED', label: 'Revision Requested' },
    { value: 'PUBLISHER_ORDER_REJECTED', label: 'Rejected' },
    { value: 'PENDING_PUBLICATION', label: 'Pending Publication' },
    { value: 'PUBLISHER_ORDER_LIVE', label: 'Live' },
    { value: 'PUBLISHER_ORDER_INDEXED', label: 'Indexed' },
    { value: 'PUBLISHER_ORDER_PAID', label: 'Paid' },
  ],
});

export const expandHiddenPublisherOrderStatusFilters = (
  filters: FilterStateType<PublisherOrderFilterFieldMap>[]
): FilterStateType<PublisherOrderFilterFieldMap>[] =>
  filters.flatMap((filter) => {
    const isLiveStatus =
      filter.field === PublisherOrderFilterField.DROPDOWN_ORDER_STATUS &&
      typeof filter.value === 'object' &&
      filter.value !== null &&
      'value' in filter.value &&
      filter.value.value === 'PUBLISHER_ORDER_LIVE';

    if (!isLiveStatus) return [filter];

    return [
      filter,
      {
        ...filter,
        value: {
          value: 'PUBLISHER_ORDER_PENDING_LIVE',
          label: 'Live',
        },
        join: FilterJoins[1].value,
      },
    ];
  });

export const getPublisherOrderFilterFields = (): FilterFieldType[] => {
  return [
    {
      label: 'Order number',
      type: 'string',
      value: PublisherOrderFilterField.STRING_ORDER_NUMBER,
    },
    {
      label: 'Website',
      type: 'string',
      value: PublisherOrderFilterField.STRING_ORDER_DOMAIN,
    },
    {
      label: 'Title',
      type: 'string',
      value: PublisherOrderFilterField.STRING_ORDER_TITLE,
    },
    {
      label: 'Deadline',
      type: 'date',
      value: PublisherOrderFilterField.DATE_ORDER_DEADLINE_AT,
    },
    {
      label: 'Requested date',
      type: 'date',
      value: PublisherOrderFilterField.DATE_ORDER_REQUESTED_AT,
    },
    {
      label: 'Status',
      type: 'enumString',
      value: PublisherOrderFilterField.DROPDOWN_ORDER_STATUS,
      inputOptions: [
        { value: 'PENDING_PUBLISHER_APPROVAL', label: 'Pending Approval' },
        { value: 'REVISION_REQUESTED', label: 'Revision Requested' },
        { value: 'PUBLISHER_ORDER_REJECTED', label: 'Rejected' },
        { value: 'PENDING_PUBLICATION', label: 'Pending Publication' },
        { value: 'PUBLISHER_ORDER_LIVE', label: 'Live' },
        { value: 'PUBLISHER_ORDER_INDEXED', label: 'Indexed' },
        { value: 'PUBLISHER_ORDER_PAID', label: 'Paid' },
      ],
    },
    {
      label: 'Price',
      type: 'number',
      value: PublisherOrderFilterField.NUMBER_ORDER_PRICE,
    },
  ];
};
